module.exports = __webpack_public_path__ + "img/osiris-cover.2e0466bd.jpg";